import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <>
    <svg className={className} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.00004 5.4445L12.4445 0L14 1.55556L8.55559 7.00004L14 12.4445L12.4445 14L7.00004 8.55559L1.55556 14L0 12.4445L5.4445 7.00004L0 1.55556L1.55556 0L7.00004 5.4445Z" fill="#090909" />
    </svg>
  </>
);

export default Icon;


